export const countryCodeOptions = [
    { value: "+91", label: "+91" },
    { value: "+1", label: "+1" },
    { value: "+44", label: "+44" },
    { value: "+61", label: "+61" },
    { value: "+971", label: "+971" },
    { value: "+65", label: "+65" },
    { value: "+81", label: "+81" },
    { value: "+49", label: "+49" },
    { value: "+33", label: "+33" },
    { value: "+60", label: "+60" },
];

export const industryOptions = [
    { value: "Advertising, Media & Marketing Services", label: "Advertising, Media & Marketing Services" },
    { value: "Arts & Crafts", label: "Arts & Crafts" },
    { value: "Automobile & Auto Parts", label: "Automobile & Auto Parts" },
    { value: "Beauty & Personal Care", label: "Beauty & Personal Care" },
    { value: "Business & Enterprise", label: "Business & Enterprise" },
    { value: "Clothing & Apparel", label: "Clothing & Apparel" },
    { value: "E-commerce Marketplace", label: "E-commerce Marketplace" },
    { value: "Education & Training", label: "Education & Training" },
    { value: "Electronics & Appliances", label: "Electronics & Appliances" },
    { value: "Food & Beverages", label: "Food & Beverages" },
    { value: "Information Technology", label: "Information Technology" },
    { value: "Insurance, Finance & Banking", label: "Insurance, Finance & Banking" },
    { value: "Manufacturing & Industrial Products", label: "Manufacturing & Industrial Products" },
    { value: "Medical & Healthcare", label: "Medical & Healthcare" },
    { value: "Property & Real Estate", label: "Property & Real Estate" },
    { value: "Shopping & Retail", label: "Shopping & Retail" },
    { value: "Travel & Tourism", label: "Travel & Tourism" },
    { value: "Others", label: "Others" },
];

export const initialErrorList = {
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
};

export const inputInitialValues = {
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    countryCode: "+91",
    companyName: "",
    website: "",
    location: "",
    designation: "",
    industry: "",
    yearStarted: "",
};
